"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatter_1 = require("../utils/formatter");
var query_1 = require("../models/query");
var get_1 = require("../utils/get");
var typeChecks_1 = require("../utils/typeChecks");
var Transform_1 = require("./transform/Transform");
var Query_1 = require("./Query");
var isArrayLike_1 = require("../utils/isArrayLike");
var object_1 = require("../utils/object");
var utils_1 = require("../utils");
exports.MAX_CALL_STACK_LEVEL = 50;
var BaseQuery = /** @class */ (function () {
    function BaseQuery(queryOptions, translationHelper) {
        var _this = this;
        this.queryOptions = queryOptions;
        this.translationHelper = translationHelper;
        this.debug = {
            error: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.error], messages));
            },
            info: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.info], messages));
            },
            warn: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.warn], messages));
            },
        };
        this.sorters = {
            date: function (a, b) {
                var aDate = new Date(a);
                var bDate = new Date(b);
                return Number(aDate) - Number(bDate);
            },
            number: function (a, b) {
                return a - b;
            },
            string: function (a, b, culture) {
                var aString = a.toString().toUpperCase();
                var bString = b.toString().toUpperCase();
                return aString.localeCompare(bString, culture);
            },
        };
    }
    BaseQuery.prototype.debugBase = function (type) {
        var messages = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            messages[_i - 1] = arguments[_i];
        }
        if (this.queryOptions && this.queryOptions.debug && this.queryOptions.debug.key) {
            var prefix = "QueryOptions Debug - \"" + this.queryOptions.debug.key + "\": ";
            console[type].apply(console, __spreadArrays([prefix], messages));
        }
    };
    Object.defineProperty(BaseQuery.prototype, "options", {
        get: function () {
            if (!this.rawOptions) {
                this.rawOptions = this.getOptions();
            }
            return this.rawOptions;
        },
        enumerable: true,
        configurable: true
    });
    BaseQuery.prototype.fillKeyFromQuery = function (fillKey, queryKey, executionOptions) {
        var childQueryOptions = (this.options && this.options[queryKey]);
        if (this.options && childQueryOptions) {
            var query = new Query_1.Query(childQueryOptions, this.translationHelper);
            this.options[fillKey] = query.execute(executionOptions);
        }
    };
    BaseQuery.prototype.initialize = function (executionOptions) {
        // Used to override
    };
    BaseQuery.prototype.execute = function (executionOptions, callStackLevel) {
        if (callStackLevel === void 0) { callStackLevel = 1; }
        if (callStackLevel > exports.MAX_CALL_STACK_LEVEL) {
            console.warn('BaseQuery MAX_CALL_STACK_LEVEL exceeded');
            return;
        }
        this.debug.info('Initialize started');
        this.initialize(executionOptions);
        var culture = executionOptions.culture, defaultPlaceholder = executionOptions.placeholder, translate = executionOptions.translate;
        var _a = this.queryOptions, format = _a.format, _b = _a.placeholder, placeholder = _b === void 0 ? defaultPlaceholder : _b, performanceCheckPlaceholder = _a.performanceCheckPlaceholder, transforms = _a.transforms, sort = _a.sort;
        // Validate that the performance values are allowed and this is a performance value
        if (!this.passesPerformanceCheck(executionOptions)) {
            this.debug.info('Performance check failed');
            var performanceCheckPlaceholderValue = void 0;
            if (performanceCheckPlaceholder) {
                var placeHolderQuery = new Query_1.Query(performanceCheckPlaceholder);
                performanceCheckPlaceholderValue = placeHolderQuery.execute(executionOptions);
            }
            return performanceCheckPlaceholderValue || placeholder;
        }
        var rawValue = this.getRawValue(executionOptions, callStackLevel);
        this.debug.info('getRawValue = ', rawValue);
        if (typeChecks_1.isNullOrUndefined(rawValue)) {
            rawValue = placeholder;
            this.debug.info('rawValue set to placeholder');
        }
        if (transforms) {
            this.debug.info('has transforms');
            for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
                var transformOptions = transforms_1[_i];
                this.debug.info("Starting transform of type: \"" + transformOptions.transformOptionsType + "\"", { transformOptions: transformOptions });
                this.debug.info("rawValue before transform", { rawValue: rawValue });
                var transform = new Transform_1.Transform(transformOptions, this.translationHelper, callStackLevel);
                rawValue = transform.execute(rawValue, this.queryOptions, executionOptions);
                this.debug.info("rawValue after transform", { rawValue: rawValue });
            }
        }
        if (format) {
            this.debug.info('has format');
            this.debug.info("rawValue before format", { rawValue: rawValue });
            rawValue = this.applyFormat(format, rawValue, executionOptions);
            this.debug.info("rawValue after format", { rawValue: rawValue });
        }
        if (translate && typeof rawValue === 'string') {
            this.debug.info('has translate');
            this.debug.info("rawValue before translate", { rawValue: rawValue });
            rawValue = translate(rawValue);
            this.debug.info("rawValue after translate", { rawValue: rawValue });
            this.debug.info('response', { rawValue: rawValue });
            return rawValue;
        }
        if (Array.isArray(rawValue) && sort) {
            this.debug.info('has sort');
            this.debug.info("rawValue before sort", { rawValue: rawValue });
            rawValue = this.applySort(rawValue, sort, culture, executionOptions.inputs);
            this.debug.info("rawValue after sort", { rawValue: rawValue });
        }
        this.debug.info('response', { rawValue: rawValue });
        return rawValue;
    };
    BaseQuery.prototype.applyFormat = function (format, rawValue, executionOptions) {
        var currency = executionOptions.currency, culture = executionOptions.culture, translate = executionOptions.translate;
        if (format.globalFormatKey) {
            var globalFormat = executionOptions && executionOptions.globalFormatsByKey && executionOptions.globalFormatsByKey[format.globalFormatKey];
            if (globalFormat && globalFormat.format) {
                format = object_1.deepMergeObjects(globalFormat.format, format);
            }
        }
        var type = format.type, transforms = format.transforms, options = format.options, _a = format.optionsByCulture, optionsByCulture = _a === void 0 ? {} : _a;
        var optionByCulture = optionsByCulture[culture];
        var _b = this.queryOptions.subQueries, subQueries = _b === void 0 ? [] : _b;
        var workingCurrency = currency;
        if (subQueries) {
            var currencyQueryOptions = subQueries.find(function (subQuery) { return subQuery.queryId === 'currency'; });
            if (currencyQueryOptions) {
                var currencyQuery = new Query_1.Query(currencyQueryOptions);
                workingCurrency = currencyQuery.execute(executionOptions);
            }
        }
        return formatter_1.default(type, culture, workingCurrency, optionByCulture || options, rawValue, transforms, translate);
    };
    BaseQuery.prototype.passesPerformanceCheck = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        var _a = (context || {}).isPerformanceAllowed, isPerformanceAllowed = _a === void 0 ? false : _a;
        var checkPerformanceAllowed = this.queryOptions.checkPerformanceAllowed;
        return (!checkPerformanceAllowed || isPerformanceAllowed);
    };
    BaseQuery.prototype.applySort = function (collection, sorts, culture, inputs) {
        var _this = this;
        if (sorts) {
            var orders_1 = {};
            if (!Array.isArray(sorts) || !isArrayLike_1.isArrayLike(sorts)) {
                sorts = [sorts];
            }
            sorts.forEach(function (sort, sortIndex) {
                if (sort.order && sort.order.length > 0) {
                    var order = sort.translateOrderValues && _this.translationHelper && _this.translationHelper.translate ?
                        sort.order.map(function (value) { return _this.translationHelper.translate(value); }) :
                        sort.order;
                    if (inputs) {
                        /**
                         * Due to the replacePlaceholders expecting the AppParamsHelper to get the embed values
                         * and it not being available to the Queries as the app initialize the AppParamsHelper
                         * and populates the executionOptions.inputs based on that initialization,
                         * we need to create a mock AppParamsHelper with the values on the rawAppParams
                         * for use by the replace placeholders.
                         * This will maintain consistency between Fund Center and the apps.
                         * We could not update replacePlaceholders to not use the appParamsHelper as we are not
                         * sure if there are any other application that might be using this.
                         */
                        var appParams_1 = { rawAppParams: inputs };
                        order = order.map(function (value) { return utils_1.replacePlaceholders({ text: value, appParamsHelper: appParams_1 }); });
                    }
                    var key = "sort_" + sortIndex;
                    orders_1[key] = order;
                    sort['_sortKey'] = key;
                }
            });
            /*
                collection = collection
                        .map((value) => {
                            const orderIndex = order.indexOf(value[sort.key]);
                            value.__order =
                                orderIndex > -1 ? orderIndex : order.length;
                            return value;
                        })
                        .sort((a, b) => this.sorters.number(a.__order, b.__order))
                        .map((value) => {
                            delete value.__order;
                            return value;
                        });
            */
            var getOrderValue_1 = function (sort, value) {
                var order = orders_1[sort['_sortKey']];
                var orderIndex = order.indexOf(value[sort.key]);
                return orderIndex > -1 ? orderIndex : order.length;
            };
            var innerSort_1 = function (a, b, sort) {
                if (sort.order && sort['_sortKey']) {
                    var aOrder = getOrderValue_1(sort, a);
                    var bOrder = getOrderValue_1(sort, b);
                    return _this.sorters.number(aOrder, bOrder);
                }
                var sortFunction = _this.sorters[sort.type];
                if (sortFunction) {
                    var aValue = get_1.get(a, sort.key);
                    var bValue = get_1.get(b, sort.key);
                    return sortFunction(aValue, bValue, culture);
                }
                return 0;
            };
            collection.sort(function (a, b) {
                for (var _i = 0, _a = sorts; _i < _a.length; _i++) {
                    var sort = _a[_i];
                    var result = innerSort_1(a, b, sort);
                    if (result !== 0) {
                        if (sort.direction === 'DESC') {
                            result = result * -1;
                        }
                        return result;
                    }
                }
                return 0;
            });
            sorts.forEach(function (sort) {
                delete sort['_sortKey'];
            });
        }
        return collection;
    };
    BaseQuery.prototype.getScenarioFromContext = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            return context.scenario;
        }
        return;
    };
    BaseQuery.prototype.getScenarioReportFromContext = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            return context.scenarioReport;
        }
        return;
    };
    BaseQuery.prototype.getPortfolioFromContext = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            return context.portfolio;
        }
        return;
    };
    BaseQuery.prototype.getPortfolioEntityFromContext = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            return context.portfolioEntity;
        }
        return;
    };
    BaseQuery.prototype.getFundManager = function (executionOptions) {
        var fundManagerContext = executionOptions.fundManagerContext;
        if (fundManagerContext) {
            return fundManagerContext;
        }
        return;
    };
    BaseQuery.prototype.getLoggedInUser = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context && context.loggedInUser) {
            return context.loggedInUser;
        }
        return;
    };
    BaseQuery.prototype.getStatistic = function (executionOptions) {
        var statisticContext = executionOptions.statisticContext;
        if (statisticContext) {
            return statisticContext;
        }
        return;
    };
    BaseQuery.prototype.getExternalApiResponse = function (externalApiOptions, executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            var externalApiResponses = context.externalApiResponses;
            if (externalApiResponses && externalApiOptions) {
                var id = externalApiOptions.id;
                return externalApiResponses[id];
            }
        }
        return;
    };
    BaseQuery.prototype.getExternalApiRequest = function (externalApiOptions, executionOptions) {
        var contextConfiguration = Query_1.Query.getContextConfiguration(executionOptions, this.queryOptions);
        if (contextConfiguration) {
            var id_1 = externalApiOptions.id;
            var _a = contextConfiguration.externalApiRequests, externalApiRequests = _a === void 0 ? [] : _a;
            return externalApiRequests.find(function (externalApiRequest) { return externalApiRequest.id === id_1; });
        }
        return;
    };
    return BaseQuery;
}());
exports.BaseQuery = BaseQuery;
//# sourceMappingURL=BaseQuery.js.map